export class JoinServerModel {
  owner: string;
  name: string;
  joinEUIs: Array<string>;
  url_js: string;
  url_claim: string;
  platformId: string;
  protocolVersion: string;
  security: string;
  authType: string;
  authUsername: string;
  authPassword: string;
  httpMode: string;

  constructor(
    owner: string = "",
    name: string = "",
    joinEUI: Array<string> = [],
    url_js: string = "",
    url_claim: string = "",
    platformId: string = '1',
    protocolVersion: string = '1.1',
    security: string = "SSL",
    authType: string = "None",
    authUsername: string = null,
    authPassword: string = null,
    httpMode: string = "Async"
  ) {
    this.owner = owner;
    this.name = name;
    this.joinEUIs = joinEUI;
    this.url_js = url_js;
    this.url_claim = url_claim;
    this.platformId = platformId;
    this.protocolVersion = protocolVersion;
    this.security = security;
    this.authType = authType;
    this.authUsername = authUsername;
    this.authPassword = authPassword;
    this.httpMode = httpMode;
  }

  addJoinEUI(joinEUI) {
    this.joinEUIs.push(joinEUI);
  }

  editJoinEUI(index, value) {
    this.joinEUIs[index] = value;
  }

  removeJoinEUI(index) {
    this.joinEUIs.splice(index, 1);
  }

}

